import React from 'react';
import { Layout as AntLayout, Menu, Button } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import { DashboardOutlined, UserOutlined, CarOutlined, TeamOutlined, AppstoreOutlined, DollarOutlined, BarChartOutlined, AuditOutlined, CalculatorOutlined } from '@ant-design/icons';

const { Header, Sider, Content } = AntLayout;

const Layout = ({ children, user, signOut }) => {
  const navigate = useNavigate();
  const location = useLocation();
  
  const userType = user?.attributes?.['custom:user_type'];
  const isAdmin = userType === 'admin';
  const isOwner = userType === 'owner';

  // Build menu items based on user type
  const adminMenuItems = [
    { key: '/dashboard', icon: <DashboardOutlined />, label: 'Dashboard' },
    { key: '/drivers', icon: <UserOutlined />, label: 'Drivers' },
    { key: '/trucks', icon: <CarOutlined />, label: 'Trucks' },
    { key: '/unified-actions', icon: <AppstoreOutlined />, label: 'Unified Actions' },
    { key: '/pricing', icon: <CalculatorOutlined />, label: 'Pricing' },
    { key: '/reports', icon: <BarChartOutlined />, label: 'BI Reports' },
    { key: '/audit-trail', icon: <AuditOutlined />, label: 'Audit Trail' },
    { key: '/profit-loss', icon: <DollarOutlined />, label: 'Profit & Loss' },
    { key: '/users', icon: <TeamOutlined />, label: 'User Management' }
  ];

  const ownerMenuItems = [
    { key: '/dashboard', icon: <DashboardOutlined />, label: 'Dashboard' },
    { key: '/unified-actions', icon: <AppstoreOutlined />, label: 'Unified Actions' },
    { key: '/pricing', icon: <CalculatorOutlined />, label: 'Pricing' },
    { key: '/reports', icon: <BarChartOutlined />, label: 'BI Reports' },
    { key: '/audit-trail', icon: <AuditOutlined />, label: 'Audit Trail' },
    { key: '/profit-loss', icon: <DollarOutlined />, label: 'Profit & Loss' }
  ];

  const menuItems = isAdmin ? adminMenuItems : (isOwner ? ownerMenuItems : []);

  return (
    <AntLayout style={{ minHeight: '100vh' }}>
      <Sider>
        <div style={{ padding: '12px 8px', color: 'white', textAlign: 'center' }}>
          <img 
            src="/logo.png" 
            alt="DAN-CHI LOGISTICS" 
            style={{ 
              maxWidth: '100%', 
              height: 'auto', 
              maxHeight: '35px', 
              marginBottom: '8px', 
              filter: 'brightness(0) invert(1)',
              objectFit: 'contain'
            }}
          />
          <div style={{ fontSize: '11px', opacity: 0.8 }}>Admin Portal</div>
        </div>
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={[location.pathname]}
          items={menuItems}
          onClick={({ key }) => navigate(key)}
        />
      </Sider>
      <AntLayout>
        <Header style={{ background: '#fff', padding: '0 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h2 style={{ margin: 0 }}>Business Portal</h2>
          <div>
            <span style={{ marginRight: 16 }}>Welcome, {user?.attributes?.given_name} ({userType})</span>
            <Button onClick={signOut}>Sign Out</Button>
          </div>
        </Header>
        <Content style={{ margin: '16px', padding: '24px', background: '#fff' }}>
          {children}
        </Content>
      </AntLayout>
    </AntLayout>
  );
};

export default Layout;